<template>
  <div>
    <el-alert
        v-if="!products.length"
        :closable="false"
        title="Нет данных"
        type="warning"
        style="margin-top: 20px"/>

    <div :class="['supplement-list' , !add ? 'supplement-list-scroll' : '']" >

      <supplement-item v-for="product of products"
                       :key="product.id"
                       :product="product"
                       @save="save"/>

      <el-button v-if="add"
                 @click.passive="openAddSupplementModal"
                 type="primary"
                 class="supplement-list__new-item">
        <i class="el-icon-plus"></i> Добавить БАД
      </el-button>

    </div>

  </div>
</template>

<script>
import SupplementItem from "@/components/visit/conclusion/SupplementItem.vue"

export default {
  name: "SupplementList",
  props: {
    add: {
      type: Boolean,
      default: false
    },
    products: {

      required: true,

    }
  },
  components: {
    SupplementItem,
  },
  data() {
    return {}
  },
  methods: {
    openAddSupplementModal() {
      this.$emit('openAddSupplementModal')
    },
    save() {
      this.$emit('save')
    },
  }
}
</script>

<style scoped lang="scss">

.supplement-list {
  //display: grid;
  //grid-template-columns: repeat(auto-fit, minmax(170px, 2fr));
  width: 100%;
  margin-top: 10px;

  &-scroll {
    max-height: 50vh;
    overflow-y: scroll;
  }

  @media (max-width: 1199px) {
    //grid-template-columns: repeat(3, 1fr);
  }

  &__new-item {
   width: 100%;
    padding: 12px 0!important;
  }
}
</style>
